// @ts-nocheck
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import Upload from "@toolkit/Library/Components/Icons/Upload";

const fileUpload: Styleguide["fileUpload"] = {
    defaultProps: {
        ...buttonGetFieldIconProps(Upload, "primary"),
    },
};

export default fileUpload;
